import React from 'react';
import StyledModalHeader from 'components/modal/StyledModalHeader';
import StyledModalBody from 'components/modal/StyledModalBody';

import { Modal } from 'reactstrap';

const StyledModal = ({ isOpen, toggle, children, title }) => (
  <Modal {...{ toggle, isOpen }}>
    <StyledModalHeader toggle={toggle}>{title}</StyledModalHeader>
    <StyledModalBody>{children}</StyledModalBody>
  </Modal>
);
StyledModal.displayName = 'StyledModal';

export default StyledModal;
